import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from '../../config/config.json';
import { getSingleDocument, AcceptEdit, getEditorPrice } from '../../actions/editordashboard';
import { Link } from 'react-router-dom';
import TopNav from '../includes/TopNav.js';
import { getPresentedEnglishType, getFormattedTime, getEditorDescriptionPerExtra } from '../../util/displayUtils.js';
import moment from 'moment'

class DashboardDetails extends Component {
    constructor(props) {
        super(props)
        this.docDetailsFetched = false;
    }
    componentDidMount(props) {
      this.getSingleDocument(this.props.match.params.docID);
      this.docDetailsFetched = true;
    }
    getSingleDocument(doc_ID) {
      this.props.dispatch(getSingleDocument(doc_ID))

    }
    AcceptEdit(doc_id){
      this.props.dispatch(AcceptEdit(doc_id, () => {
        this.props.history.push('/editordashboard');
      }))
    }
    render() {
      console.log("rendering details");
      console.log(this.docDetailsFetched);
      console.log(this.props);
      console.log("ended rendering details");
      if(this.docDetailsFetched && !this.props.EditorDashboard.singleSubmissionFailed){
        let extrasArr = JSON.parse(this.props.EditorDashboard.submission_details.extras);
        var extras = <div></div>;
        if(typeof extrasArr == 'object') {
          extras = extrasArr.map((submission, i) => {
            if(submission == 'Plagiarism') return(<span></span>)
            var extraDesc = getEditorDescriptionPerExtra(submission);
            return(
              <li>
                {extraDesc}
              </li>
            )
          });  
        }
        return(
            <div>
              <TopNav />
              <section>
              <div className="dashboardpaperdetails">
                  <br/><br/>
                  <h2><b>{this.props.EditorDashboard.submission_details.doc_name}</b></h2>
                  {(this.props.EditorDashboard.submission_details.doc_status == 2)?
                  <p><b>File to edit:</b> <a href={config.BASE + this.props.EditorDashboard.submission_details.doc_path} target="_blank">Download</a></p>
                  :
                  <p></p>
                  }
                  <p><b>Due Date:</b><span className="details-data"> {getFormattedTime(this.props.EditorDashboard.submission_details.due_date)}</span></p>
                  <p><b>Upload Date:</b><span className="details-data"> {getFormattedTime(this.props.EditorDashboard.submission_details.upload_date)}</span></p>
                  <p><b>Word Count:</b><span className="details-data"> {this.props.EditorDashboard.submission_details.word_count}</span></p>
                  <p><b>Time Limit: </b><span className="details-data">{this.props.EditorDashboard.submission_details.time_limit}</span></p>
                  <p><b>Edit Level: </b><span className="details-data">{this.props.EditorDashboard.submission_details.editor_level}</span></p>
                  <p><b>Price: </b><span className="details-data">{getEditorPrice(this.props.EditorDashboard.submission_details)}</span></p>
                  <p><b>Type of English: </b><span className="details-data">{getPresentedEnglishType(this.props.EditorDashboard.submission_details.english)}</span></p>
                  <p><b>Instructions:</b><span className="details-data"> {this.props.EditorDashboard.submission_details.instructions || 'none'}</span></p>
                  {(this.props.EditorDashboard.submission_details.doc_status == 2)?
                   <div>
                    {(this.props.EditorDashboard.submission_details.instructions_file_name)?
                    <p><b>Supporting File (do not edit this file):</b> <a href={config.BASE + this.props.EditorDashboard.submission_details.instrunctions_file_path + '/' + this.props.EditorDashboard.submission_details.instructions_file_name} target="_blank">Download</a></p>
                    :
                    <p></p>
                    }
                  </div>
                   :
                   <div></div>
                  }
                  {/* <p><b>Description:</b><span className="details-data"> {this.props.EditorDashboard.submission_details.description || 'none'}</span></p> */}
                  <p><b>Extras:</b></p>
                        <ul style={{'listStyleType': 'disc', 'padding-left': '40px'}}>{extras}</ul>
                  <br/>
                  <span>
                      <Link to="/editordashboard">Back</Link>
                      {(this.props.EditorDashboard.submission_details.doc_status == 1) && <div className='accept-to-edit' onClick={this.AcceptEdit.bind(this, this.props.EditorDashboard.submission_details.doc_id)}>Accept</div>}
                  </span>
              </div>
              </section>
            </div>
        )
      } else {
        return (
          <div>loading...</div>
        )
      }
    }
}

export default connect( ({EditorDashboard}) => ({EditorDashboard}) ) (DashboardDetails)



// WEBPACK FOOTER //
// ./src/components/dashboards/EditorPaperDetails.js